<template>
  <div class="sidebar-top d-print-none">
    <span class="report-icn d-none d-sm-block" :class="product.icon" />
    <h3 class="d-block text-center">{{ product.title }}</h3>

    <SearchCompanies class="mt-12" button-class="btn-lg mt-3 mb-5" :withIcon="false" />
    <span class="sidebar-caption text-center" v-html="product.searchHint" />
  </div>
</template>

<script>
import SearchCompanies from './SearchCompanies';

export default {
  props: ['product'],
  components: {
    SearchCompanies,
  },
};
</script>
